import axios from 'axios';

const RESOURCE_NAME = '/trackers-startups';

export default {

    addStartups(startupIds, trackerIds) {
        return axios.post(`${RESOURCE_NAME}/add-startups`, {startup_ids: startupIds, trackers: trackerIds})
    },

    addStartupsByQuery(query, sort, trackerIds) {
        return axios.post(`${RESOURCE_NAME}/add-startups-by-query`, {query: query, sort: sort, trackers: trackerIds})
    },

    removeStartups(startupsIds, trackerIds) {
        return axios.post(`${RESOURCE_NAME}/remove-startups`, {startup_ids: startupsIds, trackers: trackerIds})
    },

    removeAllStartups(trackerId) {
        return axios.post(`${RESOURCE_NAME}/remove-all-startups?tracker_id=${trackerId}`)
    },

    getStartupsList(trackerId, data) {
        return axios.post(`${RESOURCE_NAME}/startups-list?tracker_id=${trackerId}`, data)
    },

    getPipelineStartups(trackerId, data) {
        return axios.post(`${RESOURCE_NAME}/get-pipeline-startups?tracker_id=${trackerId}`, data)
    },

    savePipelineStartups(trackerId, data) {
        return axios.post(`${RESOURCE_NAME}/save-pipeline-startups?tracker_id=${trackerId}`, data)
    },

    saveDiligenceValues(trackerId, startupId, fieldId, data) {
        return axios.post(`${RESOURCE_NAME}/save-diligence-values?tracker_id=${trackerId}&startup_id=${startupId}&field_id=${fieldId}`, data)
    },

    saveDiligenceFiles(trackerId, startupId, fieldId, data) {
        return axios.post(`${RESOURCE_NAME}/save-diligence-files?tracker_id=${trackerId}&startup_id=${startupId}&field_id=${fieldId}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
    },

    getDiligenceFieldValue(trackerId, startupId, fieldId) {
        return axios.get(`${RESOURCE_NAME}/get-diligence-field-value?tracker_id=${trackerId}&startup_id=${startupId}&field_id=${fieldId}`)
    },

    getReviews(trackerId, startupId) {
        return axios.get(`${RESOURCE_NAME}/get-reviews?tracker_id=${trackerId}&startup_id=${startupId}`)
    },

    getReviewEdit(trackerId, startupId) {
        return axios.get(`${RESOURCE_NAME}/get-review-edit?tracker_id=${trackerId}&startup_id=${startupId}`)
    },

    saveReview(trackerId, startupId, data) {
        return axios.post(`${RESOURCE_NAME}/save-review?tracker_id=${trackerId}&startup_id=${startupId}`, data)
    },

    deleteReview(trackerId, startupId) {
        return axios.post(`${RESOURCE_NAME}/delete-review?tracker_id=${trackerId}&startup_id=${startupId}`)
    },

    saveReviewFiles(reviewId, fieldId, data) {
        return axios.post(`${RESOURCE_NAME}/save-review-files?review_id=${reviewId}&field_id=${fieldId}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
    },

    getApplicationData(trackerId, startupId) {
        return axios.get(`${RESOURCE_NAME}/get-application-data?tracker_id=${trackerId}&startup_id=${startupId}`)
    },

    getStartupTrackersCount(startupId) {
        return axios.get(`${RESOURCE_NAME}/get-startup-trackers-count?startup_id=${startupId}`)
    },

    getDataForPdf(trackerId, startupId) {
        return axios.get(`${RESOURCE_NAME}/get-data-for-pdf?tracker_id=${trackerId}&startup_id=${startupId}`)
    },

    getStartupDetails(trackerId, startupId) {
        return axios.get(`${RESOURCE_NAME}/get-startup-details?tracker_id=${trackerId}&startup_id=${startupId}`)
    }
}